import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  query,
  Timestamp,
  getDoc,
  getDocs,
  updateDoc,
  increment,
  deleteDoc,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { UserAuth } from "../context/authContext";
import { db } from "../firebase-config";
import moment from "moment";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { MdDeleteOutline } from "react-icons/md";

function PostComments({
  publishedBy,
  postedByPic,
  postID,
  caption,
  publishedId,
  postCategory,
}) {
  const [comments, setComments] = useState([]);
  const [comment, setComment] = useState("");
  const [loader, setLoader] = useState(true);
  const [currentUserName, setCurrentUserName] = useState(null);
  const [currentUserPic, setCurrentUserPic] = useState(null);

  const { user } = UserAuth();

  const GetComments = async () => {
    const commentsColRef = query(
      collection(
        db,
        "users",
        publishedId,
        "Categories",
        postCategory,
        "Posts",
        postID,
        "postComments"
      )
    );

    const unsubscribe = onSnapshot(commentsColRef, (Querysnap) => {
      const cmnts = [];
      Querysnap.docs.forEach((doc) => {
        cmnts.push({ id: doc.id, data: doc.data() });
      });
      setComments(cmnts);
      setLoader(false);
    });
  };

  useEffect(() => {
    GetComments();
  }, []);

  const getUser = async () => {
    const userRef = doc(db, "users", user.uid);
    const docSnap = await getDoc(userRef);

    setCurrentUserName(docSnap.data().username);
    setCurrentUserPic(docSnap.data().profilePic);
  };

  useEffect(() => {
    getUser();
  }, []);

  const handleComment = async () => {
    const commentsColRef = collection(
      db,
      "users",
      publishedId,
      "Categories",
      postCategory,
      "Posts",
      postID,
      "postComments"
    );

    const count = "count";

    const CountDocRef = doc(
      db,
      "users",
      publishedId,
      "Categories",
      postCategory,
      "Posts",
      postID,
      "postComments",
      count
    );

    if (comment != "") {
      setComment("");

      await updateDoc(CountDocRef, {
        count: increment(1),
      });

      await addDoc(commentsColRef, {
        comment: comment,
        commentBy: currentUserName,
        commentProfPic: currentUserPic,
        commentedAt: Timestamp.fromDate(new Date()),
        commentedByUserID: user.uid,
      });
    }
  };

  let navigate = useNavigate();

  const routeChange = (name, userID) => {
    const replaced = name.replace(" ", "");
    const nav = `/profile/@${replaced}`;
    navigate(nav, { state: { userID: userID } });
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      handleComment();
    }
  };

  const deleteComment = async (commentID) => {
    const CountDocRef = doc(
      db,
      "users",
      publishedId,
      "Categories",
      postCategory,
      "Posts",
      postID,
      "postComments",
      commentID
    );

    await deleteDoc(CountDocRef);
  };

  return (
    <div className="w-full h-full overflow-hidden flex flex-col justify-between bg-[#181818]">
      <div className="w-full h-[88%] overflow-y-auto flex flex-col">
        {caption && (
          <div className="w-full flex flex-row bg-[#202020] rounded-lg p-2">
            <div
              className="w-12 h-12 rounded-full overflow-hidden mr-3 cursor-pointer"
              onClick={() => routeChange(publishedBy, publishedId)}
            >
              <img src={postedByPic} className="w-full h-full object-cover" />
            </div>
            <div className="w-[80%] flex flex-col">
              <h3 className="mb-2 font-semibold text-zinc-200 capitalize cursor-pointer">
                {publishedBy}
              </h3>
              <p className="text-sm text-zinc-400">{caption}</p>
            </div>
          </div>
        )}
        {loader === false &&
          comments.map(
            (commentaire, index) =>
              commentaire.id !== "count" && (
                <motion.div
                  key={index}
                  className="w-full flex flex-col mt-1"
                  animate={{ opacity: 1, y: 0 }}
                  initial={{ opacity: 0, y: 25 }}
                  transition={{ ease: "easeOut", duration: 0.3 }}
                >
                  <div
                    className="w-full flex flex-row rounded-lg p-2"
                    key={index}
                  >
                    <div
                      className="w-12 h-12 rounded-full overflow-hidden mr-3 cursor-pointer"
                      onClick={() =>
                        routeChange(
                          commentaire.data.commentBy,
                          commentaire.data.commentedByUserID
                        )
                      }
                    >
                      <img
                        src={commentaire.data.commentProfPic}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="w-[80%] flex flex-col">
                      <h3 className="mb-2 text-base font-medium text-zinc-200 flex flex-col">
                        <p className="flex flex-row justify-between">
                          <h3
                            className="cursor-pointer"
                            onClick={() =>
                              routeChange(
                                commentaire.data.commentBy,
                                commentaire.data.commentedByUserID
                              )
                            }
                          >
                            {commentaire.data.commentBy}{" "}
                          </h3>
                          {commentaire.data.commentedByUserID === user.uid ? (
                            <MdDeleteOutline
                              size={20}
                              className="self-center fill-inputLabel animate-scale transition ease-in-out hover:scale-125 cursor-pointer"
                              onClick={() => {
                                deleteComment(commentaire.id);
                              }}
                            />
                          ) : (
                            <></>
                          )}
                        </p>

                        <span className="text-xs text-inputLabel">
                          {moment(
                            commentaire.data.commentedAt.toDate()
                          ).fromNow()}
                        </span>
                      </h3>
                      <p className="text-sm text-zinc-400">
                        {commentaire.data.comment}
                      </p>
                    </div>
                  </div>
                  {index === comments.length - 1 ? (
                    <></>
                  ) : (
                    <span className="h-[1px] w-[90%] self-center mt-1 bg-zinc-800"></span>
                  )}
                </motion.div>
              )
          )}
      </div>
      <div className="w-full h-[10%] bg-[#202020] flex flex-row justify-between items-center px-2 ">
        <input
          className="w-[85%] bg-transparent text-sm placeholder:text-zinc-600 placeholder:text-sm text-zinc-100 focus:outline-none"
          placeholder="Add a comment..."
          value={comment}
          onKeyDown={(e) => handleEnter(e)}
          onChange={(e) => setComment(e.target.value)}
        />
        <button
          className="text-zinc-500 hover:text-OrangyRed transition-all ease-in-out hover:scale-105"
          onClick={handleComment}
        >
          post
        </button>
      </div>
    </div>
  );
}

export default PostComments;
